import { ChangeDetectionStrategy, Component, Injector, Input, ViewEncapsulation } from '@angular/core';
import { FiChecklistScheduleType } from '../../fi-checklist-schedule-type';
import { FiChecklist2ScheduleFormatService } from '@fi-shared/checklist/schedule/services/fi-checklist2-schedule-format.service';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ControlValueAccessorValidatorBase } from '@fi-shared/control-value-accessor-validator-base';

@Component({
    selector: 'fi-checklist2-schedule-edit-schedule-type',
    templateUrl: './schedule-type.component.html',
    styleUrls: ['./schedule-type.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-checklist2-schedule-edit-schedule-type' },
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: FiChecklist2ScheduleEditScheduleTypeComponent,
            multi: true,
        },
        {
            provide: NG_VALIDATORS,
            useExisting: FiChecklist2ScheduleEditScheduleTypeComponent,
            multi: true,
        },
    ],
    standalone: false,
})
export class FiChecklist2ScheduleEditScheduleTypeComponent extends ControlValueAccessorValidatorBase<FiChecklistScheduleType> {
    @Input({ required: true }) auditMode: boolean;
    @Input() disabled: boolean;

    constructor(
        private injector: Injector,
        private fiChecklist2ScheduleFormatService: FiChecklist2ScheduleFormatService,
    ) {
        super(injector);
    }

    getChecklistScheduleTypes(): FiChecklistScheduleType[] {
        let scheduleTypes = !this.auditMode
            ? [FiChecklistScheduleType.Recurring, FiChecklistScheduleType.OneTime, FiChecklistScheduleType.OnDemand]
            : [FiChecklistScheduleType.Audit];
        return scheduleTypes;
    }

    isAuditScheduleType(scheduleType: FiChecklistScheduleType): boolean {
        return scheduleType === FiChecklistScheduleType.Audit;
    }

    getScheduleTypeText(scheduleType: FiChecklistScheduleType): string {
        return this.fiChecklist2ScheduleFormatService.getScheduleTypeText(scheduleType);
    }

    getScheduleTypeDescriptionText(scheduleType: FiChecklistScheduleType): string {
        return this.fiChecklist2ScheduleFormatService.getScheduleTypeDescriptionText(scheduleType);
    }

    onScheduleTypeChange() {
        this.ngModelChange.emit(this.ngModel);
    }
}
